import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_SAVE_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';
import InputContentModal from '@commons/Modals/InputContentModal';

const MODAL_WIDTH = '542px';

const isInvalidPrice = (price) => {
  if (price === '' || price === null || price === undefined) {
    return true;
  }

  const parsedPrice = parseFloat(price);

  return isNaN(parsedPrice) || parsedPrice < 0;
};

/**
 * GenericModal config of the catalog price edition (single client or selection). The parent owns
 * the price state and re-issues this config through refreshGenericModal on each keystroke so the
 * Save button's disabled state stays in sync.
 */
export const getPriceModalParams = ({ isBulk, price, onPriceChange, onSave }) => ({
  type: 'action',
  width: MODAL_WIDTH,
  height: 'auto',
  icon: '/images/inpulse/pen-black-small.svg',
  title: i18next.t(
    isBulk
      ? 'ADMIN.PRODUCTS.B2B_CATALOGS_EDIT_PRICES_MODAL_TITLE'
      : 'ADMIN.PRODUCTS.B2B_CATALOGS_EDIT_PRICE',
  ),
  component: InputContentModal,
  data: {
    autoFocus: true,
    type: 'number',
    value: price,
    description: i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_EDIT_PRICE_MODAL_CONTENT'),
    label: `* ${i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_EDIT_PRICE_MODAL_LABEL')}`,
    onChange: onPriceChange,
  },
  actions: [
    GENERIC_MODAL_CANCEL_BUTTON(),
    {
      ...GENERIC_MODAL_SAVE_BUTTON(),
      isDisabled: isInvalidPrice(price),
      handleClick: onSave,
    },
  ],
});

export default { getPriceModalParams };
